import 'babel-polyfill'
import React from 'react'
import ReactDOM from 'react-dom'
import FrontPage from './components/FrontPage'
import Building from './components/Building'
import Contact from './components/Contact'
import RegularPage from './components/RegularPage'
import MyGallery from './components/MyGallery'
import './components/Footer'
import './components/Burger'
import './components/Cookie'
import '../style/main.scss'

class Masterhuset extends React.Component {
  constructor() {
    super()
    this.state = {
      content: {}
    }
    this.getComponent = this.getComponent.bind(this)
  }
  componentDidMount() {
    this.setState({
      content: window.postData
    })
  }
  getComponent() {
    const content = window.postData
    const pageTemplate = document.getElementById('root').dataset.template
    switch (pageTemplate) {
      case 'front-page':
        return <FrontPage content={content} />
      case 'building':
        return <Building content={content} />
      case 'contact':
        return <Contact content={content} />
      case 'gallery':
        return (
          <MyGallery content={content} styles={{ paddingBottom: '100px' }} />
        )
      case 'regular':
        return <RegularPage content={content} />
      default:
        return <div className="no-template">Could not find page.</div>
    }
  }
  render() {
    return <div>{this.getComponent()}</div>
  }
}

ReactDOM.render(<Masterhuset />, document.getElementById('root'))
